import { MatcherFormNameOptions } from '../enums';

function getMatcherFormName(): MatcherFormNameOptions {
  return MatcherFormNameOptions.TAX_PRO_MATCHER_EXPERIMENT;
}

export { getMatcherFormName };
